import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Dialog, DialogTitle, DialogContent, Button, Icon } from '@material-ui/core';
import QuestionContent from './QuestionContent';
import FormContent from './FormContent';
import MessageContent from './MessageContent';
import { grey } from '@material-ui/core/colors';

const headerSizing = 'small';

const styles = () => ({
    flexRow: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    grey: {
        color: grey[600],
    },
    actionButtons: {
        float: 'right',
    },
    action: {
        marginLeft: '10px',
    },
});

class StepDialog extends React.Component {
    handleClose = () => {
        this.props.onClose();
    };

    handleSave = () => {
        this.props.handleEditStep(this.props.step);
        this.props.onClose();
    };

    render() {
        let content;
        let stepType;

        if (this.props.step.choices) {
            content = <QuestionContent steps={this.props.steps} currStep={this.props.currStep} />;
            stepType = 'Question';
        } else if (this.props.step.form) {
            content = <FormContent forms={this.props.forms} />;
            stepType = 'Form';
        } else {
            content = <MessageContent />;
            stepType = 'Message';
        }

        return (
            <React.Fragment>
                <Dialog fullWidth maxWidth={'sm'} open={this.props.open}>
                    <DialogTitle disableTypography={true} className={this.props.classes.grey}>
                        <Icon fontSize={headerSizing}>edit_Icon</Icon>
                        {`Edit ${stepType} Step`}

                        <div className={this.props.classes.actionButtons}>
                            <Button size="small" onClick={this.handleClose} className={this.props.classes.action}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={this.handleSave}
                                color="primary"
                                className={this.props.classes.action}
                            >
                                Save
                            </Button>
                        </div>
                    </DialogTitle>
                    <DialogContent>{content}</DialogContent>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(StepDialog);
